import color from 'color';
import styled from 'styled-components';
import { Menu } from '../../Menu';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const activeMenuBackgroundColor = (theme) => color(theme.greys.midnight).mix(color(theme.colors.sudoBlue), 0.3).hex();
export const SidebarMenu = styled(Menu) `
  &.ant-menu,
  .ant-menu {
    background-color: transparent;
    border-right: none;
    color: white;

    // Menu item containers
    .ant-menu-item,
    .ant-menu-submenu,
    .ant-menu-submenu-title {
      margin-top: 0;
      margin-bottom: 0;
      width: 100%;
      height: auto;
      padding-top: 0;
      padding-bottom: 0;
    }

    // SubMenu background color
    .ant-menu-item,
    .ant-menu-submenu {
      background-color: ${({ theme }) => theme.greys.midnight};
    }

    // SubMenu height adjustment
    .ant-menu-sub.ant-menu-inline > .ant-menu-item,
    .ant-menu-sub.ant-menu-inline
      > .ant-menu-submenu
      > .ant-menu-submenu-title {
      height: 50px;
    }

    // Menuitem links
    a {
      display: block;
      margin-top: 8px;
      margin-bottom: 8px;
      line-height: 40px;
      color: white;
      text-decoration: none;
      cursor: pointer;
    }

    // Menu item hover state
    .ant-menu-submenu-active,
    .ant-menu-item-active {
      background-color: ${({ theme }) => activeMenuBackgroundColor(theme)};
      color: white;
    }

    // Remove antd flash effect from theme
    .ant-menu-submenu-title:active {
      background-color: ${({ theme }) => activeMenuBackgroundColor(theme)};
    }

    // Menu item selected state
    .ant-menu-item-selected {
      background-color: ${({ theme }) => activeMenuBackgroundColor(theme)};

      &:after {
        border-right: 4px solid ${({ theme }) => theme.colors.sudoBlue};
      }
    }

    .ant-menu-submenu-selected {
      background-color: ${({ theme }) => activeMenuBackgroundColor(theme)};
    }

    // Expand/contract icon
    .ant-menu-submenu,
    .ant-menu-submenu:hover {
      .ant-menu-submenu-arrow:before,
      .ant-menu-submenu-arrow:after {
        color: white;
        background: #fff;
      }
    }
  }
`;
